import { render, staticRenderFns } from "./ChargeRemindManage.vue?vue&type=template&id=65eb094f&"
import script from "./ChargeRemindManage.vue?vue&type=script&lang=js&"
export * from "./ChargeRemindManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports